import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useGlobalContext } from "../../hooks/context";
import UserAccess from "../../components/404/UserAccess";

const {
  REACT_APP_LOGIN_CLIENT_EMAIL: clientEmail,
  REACT_APP_LOGIN_PAYMENT_EMAIL: paymentEmail,
} = process.env;

export default function PrivateOutlet() {
  const location = useLocation();
  const { user } = useGlobalContext();
  const { isLoggedIn, email } = user || {};

  const isAccess =
    isLoggedIn && (email === clientEmail || email === paymentEmail);

  if (isAccess) {
    return <Outlet />;
  } else if (isLoggedIn && email !== clientEmail) {
    return <UserAccess />;
  } else {
    return <Navigate to="/login" state={{ from: location }} />;
  }
}
